module.exports = __webpack_public_path__ + "static/media/DSC09813_20180710_074-10.e0e088dd.jpg";